import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { scroller } from 'react-scroll';
import styled from 'styled-components';
import { Typo, Icon } from 'tmt-ui-kit';

// import NewLoader from '~/components/Loader/NewLoader';
import Link from '~/components/Link/Link';
import FilterMenu from '~/components/Filter/FilterMenu';
import useSocialShare from '~/utils/hooks/socials/use-social-share';

import Colors from '~/utils/colors';
import scrollTo from '~/utils/scroller';
import { path } from '~/utils/media';
import config from '~/config';


const Title = styled(Typo.HeaderOne)`
  font-size: 36px !important;
  font-weight: 500 !important;
  text-align: center;
  margin: 0 auto 42px;
  color: ${props => props.theme.white} !important;
  
  @media only screen and (max-width: 600px){
    width: 100%;
    font-size: 24px !important;
    text-align: left;
    margin: 0;
    margin-bottom: 8px;
  }
  @media only screen and (max-width: 430px){
    width: 80%;
    font-size: 24px !important;
    text-align: left;
  }
  ${props => props.specialStyles && `${props.specialStyles.Title}`}
`;

const ShareIcon = styled(Icon)`
  @media(max-width: 1200px) {
    font-size: 32px !important;
  }
`;

const ShareContainer = styled.div`
  z-index: 30;
  flex: 1;
  >a {
    color: ${Colors.white};
    >i {
      font-size: 40px;
    }
  }
  >button {
    cursor: pointer;
    margin: 0px;
    padding: 0px;
    background: transparent;
    border: none;
    color: ${Colors.white};
    >i {
      font-size: 40px;
    }
  }
`;

const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: 50%;
  height: 650px;
  position: relative;
  box-sizing: border-box;
  @media(max-width: 1200px) {
    height: 432px;
  }
  @media(max-width: 600px) {
    padding: 28px;
    height: 281px;
    justify-content: left;
    align-items: flex-start;
  }
`;

const BannerImage = styled.img`
  position: absolute;
  z-index: 10;
  object-fit: cover;
  font-family: 'object-fit: cover;';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  ${props => props.specialStyles && `${props.specialStyles.BannerImage}`}
`;

const BannerTextContainer = styled.div`
  @media(min-width: 601px) and (max-width: 1200px) {
    padding: 24px;
  }
`;

const BannerPartnerContainer = styled.div`
  margin: -96px auto 24px auto;
  width: 96px;
  height: 96px;
  overflow: hidden;
  @media(max-width: 600px) {
    width: 72px;
    height: 72px;
    margin: 0;
    margin-bottom: 8px;
  }
  ${props => props.specialStyles && `${props.specialStyles.BannerPartnerContainer}`}
`;

const BannerPartnerIcon = styled.img`
  height: auto;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
`;

const BannerOverlay = styled.div`
  z-index: 20;
  text-align: center;
  @media(max-width: 600px) {
    text-align: left
  }
`;

const BlackOpacity = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, .6), rgba(0, 0, 0, .43) 14%, rgba(0, 0, 0, .3) 28%, rgba(0, 0, 0, .0));
  z-index: 20;
`;

const BottomOverlay = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100px;
  opacity: 0.65;
  background-image: linear-gradient(to top, #000000, rgba(0, 0, 0, 0.52) 57%, rgba(0, 0, 0, 0));
  z-index: 20;
`;

const BannerLastRow = styled.div`
  position: absolute;
  right: 21px;
  top: 21px;
  display: flex;
  .share {
    display: none;
    >button {
      cursor: pointer;
      margin: 0px;
      padding: 0px;
      background: transparent;
      border: none;
      color: ${Colors.white};
      >i {
        font-size: 40px;
        color: ${Colors.white};
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .socials{
      display: none;
    }
    .share {
      display: inline;
    }
  }
`;

const ExploreCitiesButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  @media only screen and (max-width: 600px) {
    margin-top: 12px;
    justify-content: left;              
  }
`;

const ExploreCitiesButton = styled.button`
  cursor: pointer;
  padding: 0px 20px 0px 16px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  user-select: none;
  background: ${Colors.white};
  border: none;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  >p {
    transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);               
  }
  &:hover {
    color: ${Colors.white} !important;
    background: ${Colors.darkOrange};
    >p {
      color: ${Colors.white} !important;
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);              
    }
  }
  @media only screen and (max-width: 600px) {
    padding: 0px 16px 0px 4px;             
  }
`;

const BreakpointContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

const ButtonBreakpoint = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 8px;
`;

const ReadMore = styled(Typo.Paragraph)`
  margin: 0px;
  font-weight: normal !important;
  color: ${props => props.theme.white} !important;
`;

const ReadMoreIcon = styled(Icon)`
  color: ${props => props.theme.white} !important;
  display: block;
  margin: -4px auto 0;
`;

const getInitialState = props => {
  const activity = props.url ? props.url.query.activity : '';
  const isActivity = props.activities && props.activities.find(c => c.value === activity);
  const defaultActivity = props.activities && props.activities.length > 0 && props.activities[0].value;
  return {
    mounted: false,
    hideNavbar: false,
    bannerImage: isActivity ? activity : defaultActivity
  };
};

const SocialShare = () => {
  const { openFacebook, openTwitter, openPinterest } = useSocialShare();
  return (
    <ShareContainer>
      <button onClick={openFacebook}>
        <Icon name="facebook" />
      </button>
      <a href="https://www.instagram.com/takemetour_thailand/" target="_blank" rel="noopener noreferrer" className="button-socials">
        <Icon name="instagram" />
      </a>
      <button onClick={openTwitter}>
        <Icon name="twitter" />
      </button>
      <button onClick={openPinterest}>
        <Icon name="pinterest" />
      </button>
    </ShareContainer>
  );
};

export default class BannerTopic extends Component {
  static propTypes = {
    hideOtherCities: PropTypes.bool,
    url: PropTypes.object,
    objects: PropTypes.object,
    // activities: PropTypes.array,
    // headTags: PropTypes.object,
    location: PropTypes.string,
    isOpen: PropTypes.func,
    setFilterInfo: PropTypes.func,
    logFilterActivity: PropTypes.func,
    filterInfo: PropTypes.object,
    useNewFilter: PropTypes.bool,
    combinedDynamicLoaded: PropTypes.bool,
    hasBreakpoint: PropTypes.bool,
    // notSquareLogo: PropTypes.bool
    specialStyles: PropTypes.string
  };

  static defaultProps = {
    useNewFilter: false
  };

  state = getInitialState(this.props);

  componentDidMount() {
    this.setState({ mounted: true }); // eslint-disable-line
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.useNewFilter) {
      const { activity } = this.props.url.query;
      if (activity !== nextProps.url.query.activity) {
        this.setState({ bannerImage: nextProps.url.query.activity });
      }
    }
  }

  render() {
    const { location, url, useNewFilter, combinedDynamicLoaded, hasBreakpoint, specialStyles = '', isShowFilter } = this.props;
    const { image, image_alt, isPartner, partnerImage, partnerImageAlt, title } = this.props.objects; // eslint-disable-line
    const { bannerImage, mounted } = this.state;
    const bannerTitle = location ? `${location} Selected Local Experiences` : title;
    const bannerAlt = image_alt || bannerTitle; // eslint-disable-line
    let otherLink = '/other-cities';
    if (location === 'Siem Reap') {
      otherLink = '/to/Battambang';
    } else if (['Kampot', 'Phnom Penh', 'Battambang'].indexOf(location) !== -1) {
      otherLink = '/to/Siem Reap';
    }
    return (
      <BannerContainer>
        <BlackOpacity />
        <BottomOverlay />
        <BannerImage
          className="banner-image"
          src={
            (isShowFilter && bannerImage && `${config.assetPath}/static/images/Filter/${bannerImage}.jpg`)
            || (image && path(image, 'tripCover'))
            || `${config.assetPath}/static/images/City/city-default.jpg`
          }
          srcSet={`${
            (isShowFilter && bannerImage && `${config.assetPath}/static/images/Filter/${bannerImage}.jpg`)
            || (image && path(image, 'tripCoverMobile'))
            || `${config.assetPath}/static/images/City/city-default.jpg`
          } 600w, ${
            (isShowFilter && bannerImage && `${config.assetPath}/static/images/Filter/${bannerImage}.jpg`)
            || (image && path(image, 'tripCoverIphone'))
            || `${config.assetPath}/static/images/City/city-default.jpg`
          } 1200w, ${
            (isShowFilter && bannerImage && `${config.assetPath}/static/images/Filter/${bannerImage}.jpg`)
            || (image && path(image, 'tripCover'))
            || `${config.assetPath}/static/images/City/city-default.jpg`
          } 1600w`}
          alt={bannerAlt}
          specialStyles={specialStyles}
        />
        <BannerOverlay>
          <BannerTextContainer>
            {(isPartner && partnerImage) && (
              <BannerPartnerContainer specialStyles={specialStyles}>
                <BannerPartnerIcon
                  className="banner-partner-icon"
                  src={path(partnerImage, 'fullSize', false, true)}
                  alt={partnerImageAlt}
                />
              </BannerPartnerContainer>
            )}
            <Title specialStyles={specialStyles}>{bannerTitle}</Title>
            <BannerLastRow>
              <div className="socials">
                {mounted && <SocialShare />}
              </div>
              <div className="share">
                <button onClick={this.props.isOpen}>
                  <ShareIcon name="share" />
                </button>
              </div>
            </BannerLastRow>
            {/* {combinedDynamicLoaded && <NewLoader />} */}
            {!useNewFilter && !this.props.hideOtherCities && combinedDynamicLoaded && (
              <ExploreCitiesButtonContainer>
                <Link to={otherLink} >
                  <ExploreCitiesButton>
                    <Icon name="map-pin" />
                    <Typo.Paragraph>Explore Other Cities</Typo.Paragraph>
                  </ExploreCitiesButton>
                </Link>
              </ExploreCitiesButtonContainer>
            )}
            {useNewFilter && !combinedDynamicLoaded && (
              <FilterMenu
                url={url}
                filterInfo={this.props.filterInfo}
                setFilterInfo={this.props.setFilterInfo}
                logFilterActivity={this.props.logFilterActivity}
              />
            )}
            {!!hasBreakpoint && (
              <BreakpointContainer>
                <ButtonBreakpoint onClick={() => {
                  scrollTo('breakpoint', {
                    offset: -100,
                    duration: 500,
                    smooth: true,
                  });
                  if (this.props.logClickBreakpoint && location) {
                    this.props.logClickBreakpoint(location);
                  }
                }}
                >
                  <ReadMore>Learn more about {location}</ReadMore>
                  <ReadMoreIcon name="chevron-down" />
                </ButtonBreakpoint>
              </BreakpointContainer>
            )}
          </BannerTextContainer>
        </BannerOverlay>
      </BannerContainer>
    );
  }
}
